import {Injectable} from "@angular/core";
import {environment} from "../environments/environment";

declare var BaasCard: any;

const TEMPO_EXPIRACAO_TOKEN_CELLCOIN_MS = 4.5 * 60 * 1000;

export interface DadosCartaoTokenizacaoCellcoin {
  number: string;
  holder: string;
  expiresAt: string;
  cvv: string;
}

@Injectable({
  providedIn: 'root'
})
export class CellcoinCartaoTokenizacaoService {
  private baasCard: any;
  private ambienteProducao: boolean;
  private promessaScript: Promise<void>;

  async inicialize(ambienteProducao: boolean = environment.production): Promise<void> {
    await this.garantaBaasCard(ambienteProducao);
  }

  async tokenize(dadosCartao: DadosCartaoTokenizacaoCellcoin,
                 ambienteProducao: boolean = environment.production): Promise<any> {
    await this.garantaBaasCard(ambienteProducao);

    const dadosTokenizacao = {
      number: this.apenasDigitos(dadosCartao.number),
      holder: String(dadosCartao.holder || '').trim(),
      expiresAt: dadosCartao.expiresAt,
      cvv: String(dadosCartao.cvv || '').trim()
    };

    const card = this.baasCard.newCard(dadosTokenizacao);
    card.validate();

    const cryptData = card.encrypt(this.baasCard._publicKey);

    return {
      token: cryptData,
      cryptData: cryptData,
      ultimosNumeros: dadosTokenizacao.number.slice(-4),
      bandeira: card.Brand ? card.Brand.name : 'Cartão de Crédito',
      tokenize: {
        provider: 'cellcoin',
        card: dadosTokenizacao,
        environment: ambienteProducao,
        dataExpiracao: new Date().getTime() + TEMPO_EXPIRACAO_TOKEN_CELLCOIN_MS
      }
    };
  }

  async retokenize(tokenize: any): Promise<any> {
    if(!tokenize || tokenize.provider !== 'cellcoin')
      throw Error('Tokenização Cellcoin inválida.');

    if(!tokenize.card)
      throw Error('Dados do cartão Cellcoin expiraram. Informe o cartão novamente.');

    const ambienteProducao = tokenize.environment == null ? environment.production : !!tokenize.environment;
    return this.tokenize(tokenize.card, ambienteProducao);
  }

  private async garantaBaasCard(ambienteProducao: boolean) {
    await this.carregueScript();

    if(!this.baasCard || this.ambienteProducao !== ambienteProducao) {
      this.baasCard = new BaasCard(ambienteProducao);
      this.ambienteProducao = ambienteProducao;
    }

    if(!this.baasCard._publicKey)
      await this.baasCard._setPublicKey();
  }

  private carregueScript(): Promise<void> {
    if(typeof BaasCard === 'function')
      return Promise.resolve();

    if(this.promessaScript)
      return this.promessaScript;

    this.promessaScript = new Promise((resolve, reject) => {
      const existente = document.getElementById('cellcoin-checkout-js') as HTMLScriptElement;
      if(existente) {
        existente.addEventListener('load', () => resolve());
        existente.addEventListener('error', () => reject(Error('Falha ao carregar checkout Cellcoin')));
        return;
      }

      const script = document.createElement('script');
      script.id = 'cellcoin-checkout-js';
      script.src = 'https://js.cel.cash/checkout-v2.min.js';
      script.onload = () => resolve();
      script.onerror = () => reject(Error('Falha ao carregar checkout Cellcoin'));
      document.body.appendChild(script);
    });

    return this.promessaScript;
  }

  private apenasDigitos(valor: any): string {
    return String(valor || '').replace(/\D/g, '');
  }
}
